export const DEEP_ARTIFACTS = [
  { slug: 'the-sovereign', name: 'The Sovereign', type: 'Pendant', caption: ['Rule the tides.', 'Command the depths.'], image: '/products/the-sovereign.webp' },
  { slug: 'the-seal', name: 'The Seal', type: 'Ring', caption: ['Bound by the ocean.', 'Marked by its will.'], image: '/products/the-seal.webp' },
  { slug: 'the-current', name: 'The Current', type: 'Tennis Necklace', caption: ['An endless flow', 'of divine presence.'], image: '/products/the-current.webp' },
  { slug: 'the-tide', name: 'The Tide', type: 'Tennis Bracelet', caption: ['Waves that never lessen.', 'Power that never fades.'], image: '/products/the-tide.webp' },
];

export const DEEP_ARTIFACTS_MORE = [
  { slug: 'the-meridian', name: 'The Meridian', type: 'Necklace', caption: ['A line of orientation,', 'balance, and return.'], image: '/products/the-meridian.webp' },
  { slug: 'the-drift', name: 'The Drift', type: 'Band', caption: ['A band of quiet movement', 'and daily power.'], image: '/products/the-drift.webp' },
  { slug: 'baton-abissos', name: 'Bâton Abissos', type: 'Masterwork', caption: ['A trident-inspired weapon', 'recovered as heirloom.'], image: '/products/baton-abissos.webp' },
];

export const DEEP = {
  slug: 'the-deep',
  numeral: 'I',
  position: '01',
  name: 'The Deep',
  subtitle: 'The ocean answered.',
  passage: [
    'In the beginning, Ikarus descended into waters so ancient they remembered the first breath of creation.',
    'The Deep does not speak.\nIt listens.',
  ],
  artifactsIntro: 'Symbols of dominion, currents, and the unfathomable.',
  quote: 'The Deep does not reveal itself to those who seek power. Only to those who accept their smallness.',
  scene: '/realms/deep-scene.webp',
  sceneMobile: '/realms/deep-scene-m.webp',
  gold: '/realms/deep-gold.webp',
  goldMobile: '/realms/deep-gold-m.webp',
  sky: '/realms/deep-sky.webp',
  water: '/realms/deep-water.webp',
  extLeft: '/realms/deep-ext-left.webp',
  extRight: '/realms/deep-ext-right.webp',
  lineArt: '/realms/deep-trident-art.webp',
  quoteArt: '/realms/deep-hands.webp',
  // brightest gold points on the scene (% of plate width/height)
  twinkles: [
    { x: 84.63, y: 34.34, size: 2.6, dur: 9, delay: 0.5 },
    { x: 73.99, y: 82.88, size: 1.4, dur: 11, delay: 4.2 },
    { x: 91.39, y: 54.47, size: 1.3, dur: 12, delay: 7.7 },
    { x: 69.63, y: 31.23, size: 1.3, dur: 10, delay: 2.1 },
    { x: 89.34, y: 73.67, size: 1.2, dur: 13, delay: 9.6 },
    { x: 76.88, y: 27.11, size: 1.1, dur: 11.5, delay: 6.1 },
    { x: 86.17, y: 48.77, size: 1.1, dur: 12.5, delay: 11.3 },
    { x: 86.96, y: 19.85, size: 1.1, dur: 10.5, delay: 3.3 },
    { x: 78.74, y: 35.0, size: 1, dur: 13.5, delay: 8.8 },
    { x: 53.09, y: 38.57, size: 1, dur: 12, delay: 1.4 },
    { x: 63.18, y: 67.22, size: 1, dur: 11, delay: 5.5 },
    { x: 69.69, y: 56.25, size: 1, dur: 12.5, delay: 10.4 },
    { x: 79.56, y: 70.49, size: 0.9, dur: 10, delay: 12.1 },
  ],
  mobileCrop: { x: 330, w: 580, srcW: 1024 },
};
